import { createFileRoute } from '@tanstack/react-router';
import { AiChatLayoutComponent } from '@/app/route-components/AiChatLayoutComponent';

/**
 * /ai-chat 配下の共通レイアウトルート。
 * サイドバー + コンテンツエリアを 1 度だけ描画し、子ルートは Outlet で差し込む。
 */
export const Route = createFileRoute('/_protected/ai-chat')({
  component: AiChatLayoutComponent,
});
